import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getResults } from "../services/api";
import { saveResults } from "../store/assessmentSlice";
import { useNavigate } from "react-router-dom";
import { clearTimers, readTimer, timerKey } from "../utils/timerStorage";

export const useAssessmentSubmission = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const examState = useSelector((state) => state.assessment);
  const {
    id: examId,
    savedAnswers,
    questions,
    price,
    userID,
    initialTimes,
  } = examState;

  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [isSkippedQuestions, setIsSkippedQuestions] = React.useState(false);

  const submitExam = async (params) => {
    try {
      let res = await getResults(params);
      console.log(res);
      if (res.success) {
        dispatch(saveResults(res.result));
        if (price > 0) {
          navigate("/rating");
        } else {
          navigate("/results");
        }
      }
    } catch (e) {
      console.error(e);
    }
    setSubmitLoading(false);
  };

  const handleSubmit = (force = false) => {
    if (
      savedAnswers.filter((item) => !!item).length === questions.length ||
      force
    ) {
      setSubmitLoading(true);

      // CR-03: this read the clocks under the old unscoped "timer-<index>" keys. It has
      // to use the same key the timer writes, or every elapsed time comes back as the
      // question's whole allowance - getItem returns null and null coerces to 0.
      //
      // A clock that was never started reads null, which means the student never reached
      // that question: no time elapsed, rather than all of it. A clock that ran past zero
      // is negative, so subtracting it adds the overtime on top of the allowance - which
      // is the figure the analysis page needs.
      const elapsedFor = (questionIndex) => {
        const remaining = readTimer(timerKey(examId, userID, questionIndex));
        if (remaining === null) return 0;
        return initialTimes[questionIndex] - remaining;
      };

      const totalTimeElapsed = elapsedFor(initialTimes.length - 1);
      const savedAnswersWithTime = savedAnswers.map((answer) => {
        return {
          ...answer,
          timeElapsed: elapsedFor(answer.questionIndex),
        };
      });
      submitExam({
        id: examId,
        answers: savedAnswersWithTime,
        userID,
        totalTimeElapsed: totalTimeElapsed,
      }).then((res) => {
        // Was localStorage.clear(), which also threw away anything else the app kept.
        // Only this exam's clocks are finished with.
        clearTimers(examId);
      });
    } else {
      setIsSkippedQuestions(true);
    }
  };

  return {
    handleSubmit,
    submitLoading,
    isSkippedQuestions,
  };
};
